export const ChevronMark = ({ className = "h-9 w-auto", light = false }) => {
  const green = light ? "#FAF9F5" : "#134E3A";
  const gold = "#D4AF37";
  return (
    <svg viewBox="0 0 320 220" className={className} fill="none" aria-hidden="true">
      <polygon points="0,75 55,10 110,75 88,75 55,36 22,75" fill={green} />
      <polygon points="105,75 160,10 215,75 193,75 160,36 127,75" fill={gold} />
      <polygon points="210,75 265,10 320,75 298,75 265,36 232,75" fill={green} />
      <polygon points="0,145 55,210 110,145 88,145 55,184 22,145" fill={green} />
      <polygon points="105,145 160,210 215,145 193,145 160,184 127,145" fill={gold} />
      <polygon points="210,145 265,210 320,145 298,145 265,184 232,145" fill={green} />
    </svg>
  );
};

export const Wordmark = ({ light = false, className = "" }) => (
  <span className={`leading-none ${className}`}>
    <span
      className={`block font-display text-[17px] font-extrabold tracking-tight ${
        light ? "text-bone" : "text-forest-deep"
      }`}
    >
      LearnYourWay
    </span>
    <span
      className={`mt-0.5 block font-mono text-[9px] uppercase tracking-[0.42em] ${
        light ? "text-gold" : "text-gold-dark"
      }`}
    >
      Consultants
    </span>
  </span>
);
